import { Col, Row } from 'antd';
import { FORM_ERROR } from 'final-form';
import { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { addSurvey } from '~src/modules/surveys/actions/surveyActions';
import { NewSurveySubmitData } from '~src/modules/surveys/interfaces';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import logger from '~src/services/logger/LlsLogger';
import AddItemPageHeader from '~src/shared/headers/AddItemPageHeader';
import { PageContentContainer } from '~src/styles/containers.sc';

import SurveyAddForm from './SurveyAddForm';

interface DispatchProps {
  addSurvey(survey: NewSurveySubmitData): ApiReduxResp;
}

type Props = DispatchProps & RouteComponentProps<any> & WithTranslation;

class SurveyAdd extends Component<Props> {
  submitFrm = (survey: NewSurveySubmitData) => {
    return this.props
      .addSurvey(survey)
      .then(({ response, error }) => {
        if (error) {
          return {
            name: error.response && error.response.data[0].translation_key,
            [FORM_ERROR]: 'add survey failed!',
          };
        } else if (response) {
          this.props.history.replace(`/content/surveys/${response.data.id}/?collapsedTitleForm`);
        }
      })
      .catch((error) => {
        logger.info('Error creating Survey', {
          error,
          info: {
            componentStack: 'SurveyAdd.jsx',
          },
        });
        throw error;
      });
  };

  render() {
    const { t, history } = this.props;
    return (
      <PageContentContainer>
        <Row gutter={30}>
          <Col span={12} offset={6}>
            <AddItemPageHeader
              t={t}
              titleKey="x.surveys.add.survey.title"
              subTitleKey="x.surveys.add.survey.description"
            />
          </Col>
        </Row>
        <SurveyAddForm submitFrm={this.submitFrm} history={history} />
      </PageContentContainer>
    );
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  addSurvey: (survey) => dispatch(addSurvey(survey)),
});

const SurveyAddC = connect(null, mapDispatchToProps)(SurveyAdd);
const SurveyAddR = withRouter(SurveyAddC);
const SurveyAddT = withTranslation()(SurveyAddR);

export default SurveyAddT;
